import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import api from '@/api/api'


Vue.use(Router)
// export default new Router({
//   mode: 'history',
  const routes = [
    // 登录
    {
      path: '/login',
      name: 'Login',
      component: () => import("@/components/Login"),
    },
    {
      path: '/',
      name: 'public',
      component: () => import("@/components/public"),
    },
    // 详情页
    {
      path: '/detail',
      name: 'detail',
      component: () => import("@/components/detail"),
    },
    // 详情页
    {
      path: '/renew',
      name: 'renew',
      component: () => import("@/components/renew"),
    },
    // 下单页
    {
      path: '/purchase',
      name: 'purchase',
      component: () => import("@/components/purchase"),
      beforeRouteEnter(to, from, next) {
        if (Cookies.get(`custom_tokenid`+process.env.TITLE)) {
          next()
        } else {
          next('/login');
        }
      }
    },
    // 订单详情
    {
      path: '/order_detail',
      name: 'order_detail',
      component: () => import("@/components/order_detail"),
      beforeRouteEnter(to, from, next) {
        if (Cookies.get(`custom_tokenid`+process.env.TITLE)) {
          next()
        } else {
          next('/login');
        }
      }
    },
    // 评价
    {
      path: '/evaluate',
      name: 'evaluate',
      component: () => import("@/components/evaluate"),
      beforeRouteEnter(to, from, next) {
        if (Cookies.get(`custom_tokenid`+process.env.TITLE)) {
          next()
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/login_callback',
      name: 'login_callback',
      component: () => import("@/components/login_callback"),
      beforeRouteEnter(to, from, next) {
        if (Cookies.get(`custom_tokenid`+process.env.TITLE)) {
          next()
        } else {
          next('/login');
        }
      }
    },
    // 支持的国家地区
    {
      path: '/support',
      name: 'support',
      component: () => import("@/components/support"),
    },
    // 隐私政策
    {
      path: '/protocol',
      name: 'protocol',
      component: () => import("@/components/protocol"),
    },
    // 帮助
    {
      path: '/help',
      component: () => import("@/components/help"),
    },
    // 常见问题
    {
      path: '/problem',
      name: 'problem',
      component: () => import("@/components/problem"),
      beforeRouteEnter(to, from, next) {
        if (Cookies.get(`custom_tokenid`+process.env.TITLE)) {
          next()
        } else {
          next('/login');
        }
      }
    },
    // 支付结果页
    {
      path: '/result',
      component: () => import("@/components/result"),
      beforeRouteEnter(to, from, next) {
        if (Cookies.get(`custom_tokenid`+process.env.TITLE)) {
          next()
        } else {
          next('/login');
        }
      }
    },
    // 服务登录
    {
      path: '/loginServer',
      name: 'server_login',
      component: () => import("@/components/business/server_login"),
    },
    // 确认服务
    {
      path: '/server_confirm',
      name: 'server_confirm',
      component: () => import("@/components/business/server_confirm"),
      beforeRouteEnter(to, from, next) {
        if (Cookies.get(`vendor_tokenid`+process.env.TITLE)) {
          next()
        } else {
          next('/loginServer');
        }
      }
    },
    // 确认详情
    {
      path: '/server_detail',
      name: 'server_detail',
      component: () => import("@/components/business/server_detail"),
      beforeRouteEnter(to, from, next) {
        if (Cookies.get(`vendor_tokenid`+process.env.TITLE)) {
          next()
        } else {
          next('/loginServer');
        }
      }
    },
    // 服务核销
    {
      path: '/sure_write_off',
      name: 'sure_write_off',
      component: () => import("@/components/business/sure_write_off"),
    },
    {
      path: "*",
      redirect: '/404'
    }
  ]
// })

const router = new Router({
  routes:routes,
  mode: 'history',
  base: process.env.BASE_PATH,
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
router.beforeEach((to,from,next)=>{
  let id = Math.floor(Math.random() * 101)
  axios.get(process.env.BASE_PATH + `/static/config.json?id=${id}`).then(result => {
  // axios.get(`/static/config.json?id=${id}`).then(result => {
    console.log(result.data.renew)
    if(result.data.renew === true){
      if(to.path == '/renew'){
        next()
      }else{
        next('/renew')
      }
    }else{
      if(to.path == '/renew'){
        next('/')
      }else{
        next()
      }
    }
  }).catch(error => {})
})
// router.beforeRouteEnter((to,from,next)=>{
//   if(Cookies.get(`custom_tokenid`+process.env.TITLE)){
//     next()
//   }else{
//     next('/login');
//   }
// })

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js